/* eslint-disable no-undef */
import React from "react";
import { useTranslation } from "react-i18next";
import { STARTER_PRESENTATION_URL } from "../../../constants/downloads";

const DownloadStep = () => {
  const { t } = useTranslation();

  const handleDownloadViaLink = () => {
    window.open(STARTER_PRESENTATION_URL, "_blank");
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <p style={{ textAlign: "left" }}>
        {t("walkthrough.download.content")}
        <a
          href="#"
          style={{
            color: "#0065FD",
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.preventDefault();
            handleDownloadViaLink();
          }}
        >
          {t("welcome.popup.downloadViaLink")}
        </a>
      </p>
    </div>
  );
};

export default DownloadStep;
